<script>
import wx from 'weixin-js-sdk';
import {Dialog} from "vant";
import {
  consumablesBranchOrderInfo,
  consumablesBranchOrderList,
  consumablesBranchStock,
  consumablesWarehouseStockList,
  consumablesOrderSortRelation, consumablesBranchOrderInfoId, agentInfoList, consumablesOrderSortRelationList
} from "@/lib/request";
export default {
  name: 'consumables',
  data(){
    return{
      latitude:'',
      longitude:'',
      siteId:'',
      activeTab: '1',
      warehouseName:'',
      warehouseObj:{},
      warehouseList:[
        // {
        //   "stockId": 1,
        //   "boxNumber": 2,
        //   "consumablesCode": "FI",
        //   "status": 3,
        //   "totalAmount": 0,
        //   "whId": "ck-001",
        //   "claimBoxesLimit": 1,
        //   "remark": "测试",
        //   "updateTime": "2025-08-08 18:10:36",
        //   "regionName": "西藏自治区/拉萨市",
        //   "warehouseName": "北郊服务大厅",
        //   "warehouseAddress": "拉萨市城关区扎基住宅小区4区4栋2号院"
        // }
      ],
      showWarehousePicker:false,
      shopNumber:null,
      deliveryFlag:1,
      size1:10,
      page1:1,
      regionCode:'',
      disabledFlag:false,//false:不禁用，true:禁用
      haveObj:{
        //     "branchId": 54010001,
        //     "boxNumber": 0,
        //     "remainingVolumes": 0,
        //     "consumablesCode": "FI",
        //     "status": 3,
        //     "orderStatus": 1,
        //     "claimBoxesLimit": 2,
        //     "remark": ""
      },
      deliveryType:1,
      // 列表数据
      page2:1,//当前页
      size2:20,//每页条数
      totals1:0,//总条数
      totalPages1:0,//总页数
      finished1: true,
      loading1:false,
      finishedMsgTxt:'没有更多了',
      orderList:[],
      listSite:[],
      showSiteIdPicker:false,
      //   可配送仓库（ //第二次: 拉萨、区中心、阿里不配送，其他地区仓库都配送）
      moreWarehouse:['分中心仓库','山南市服务大厅','林芝市服务大厅','北郊服务大厅','日喀则服务大厅','那曲市服务大厅','昌都市服务大厅'],
      logsFlag:false,
      formList:[],
      lastFlag:false,
      lastObj:{},
      lastList:[],
      lastType:''
    }
  },
  watch:{
    // 监控参数变化
    searchParams:function() {
      this.getListData();
    },
    // 监控参数变化
    listParams(newVal,oldVal) {
      if(newVal.branchId!==oldVal.branchId){
        this.getList();
      }else if(newVal.pageNum!==oldVal.pageNum){
        this.getList();
      }
    },
  },
  computed:{
    // 监控参数变化更新
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        regionCode:this.regionCode,
      };
    },
    // 监控参数变化更新
    listParams() {
      return {
        pageSize:this.size2,
        pageNum:this.page2,
        branchId:this.siteId,
        // status:0,
        // distributionType:this.deliveryType,//配送类型:0 配送、1 自取
        type:0,//订单类型，0:热敏纸、1:其他
        orderByColumn:'createTime',
        isAsc:'desc',//desc:降序，asc:升序
      };
    },
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if(this.page2<this.totalPages1){
          this.page2 = this.page2+1;
        }
      },1000);
    },
    onSiteIdConfirm(values){
      this.siteId = values.branchId.toString();
      this.showSiteIdPicker = false;
      this.getSearchSiteIdHave(values.branchId);
      this.getDataForm();
    },
    getUserSiteIdInfo(){
      agentInfoList({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              // 网点信息列表
              if(res.data.rows&&res.data.rows.length>0){
                this.listSite = res.data.rows[0]?.branchInfos;
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    getSearchSiteIdHave(siteId){
      consumablesBranchStock({
        stockId:siteId
      }).then((res)=>{
        if(res) {
          // status 0 无效、 1 库存充足、2 库存预警、3 库存不足
          // orderStatus 0 不可以、 1 可以
          // remainingVolumes 卷数
          if (!res.data) {
            return false;
          }
          if (!res.data.data) {
            return false;
          }
          this.haveObj = res.data.data;
        }
      });
    },
    // 选择仓库
    onWarehouseConfirm(values){
      this.warehouseObj = values;
      this.warehouseName = values.warehouseName;
      // 库存小于等于限制数量时
      if(values.boxNumber<=values.claimBoxesLimit){
        this.shopNumber = values.boxNumber;
      }else{
        this.shopNumber = values.claimBoxesLimit;
      }
      this.showWarehousePicker = false;
      //第一次: '北郊服务大厅','日喀则服务大厅','那曲市服务大厅'可配送，其他仓库不可配送
      //第二次: '分中心仓库','区中心服务大厅','山南市服务大厅','林芝市服务大厅','','北郊服务大厅','日喀则服务大厅','那曲市服务大厅','昌都市服务大厅'可配送地区仓库都配送，拉萨、阿里不配送，
      this.logsFlag = this.moreWarehouse.includes(values.warehouseName);
    },
    // // 输入申请数量
    // getOnInput(){
    //   if(!this.warehouseName){
    //     this.shopNumber = null;
    //     this.$toast('请先选择仓库！');
    //     return;
    //   }
    //   // 库存小于等于限制数量时
    //   if(this.warehouseObj.boxNumber<=this.warehouseObj.claimBoxesLimit){
    //     this.shopNumber = this.warehouseObj.boxNumber;
    //     if(this.warehouseObj.boxNumber===0){
    //       this.$toast('库存不足！');
    //       return false;
    //     }
    //   }else{
    //     this.shopNumber = this.warehouseObj.claimBoxesLimit;
    //   }
    //   if(this.shopNumber<=0){
    //     this.shopNumber = 0;
    //   }
    //   // if(this.shopNumber>=this.warehouseObj.claimBoxesLimit){
    //   //   this.shopNumber = this.warehouseObj.claimBoxesLimit;
    //   // }else{
    //   //
    //   // }
    // },
    // 仓库列表
    getListData(){
      consumablesWarehouseStockList(this.searchParams).then((res)=>{
        if(res){
          if(!res.data){
            return false;
          }
          if(!res.data.rows){
            return false;
          }
          this.warehouseList = res.data.rows;
          if(res.data.rows.length===1){
            this.warehouseName = res.data.rows[0].warehouseName;
            this.warehouseObj = res.data.rows[0];
          }
        }
      });
    },
    getReason(){
      if(this.formList.length>0){
        if(this.formList.map((item)=>item.distributionType)[0]===1){
          // 自取
          this.$toast('您有订单未领取，请勿重复下单!');
        }else{
          // 配送
          this.$toast('您有订单待配送，请勿重复下单!');
        }
      }else{
        this.$toast(`预计您还有${this.haveObj.remainingVolumes}卷，目前不能申请！`);
      }
    },
    // 提交申领订单
    getSubmitData(){
      if(!this.warehouseName){
        this.$toast('请选择仓库！');
        return;
      }
      if(!this.shopNumber){
        this.$toast('请选择申领数量！');
        return;
      }
      if(!this.deliveryFlag){
        this.$toast('请选择配送方式！');
        return;
      }
      if(this.shopNumber>0){
        let params = {
          whId:this.warehouseObj.whId,//仓库
          boxNumber:this.shopNumber,//申领数量
          distributionType:this.deliveryFlag,//配送方式
          branchId:this.siteId,//网点编号
          orderOperatorId:'',
        }
        consumablesBranchOrderInfo(params).then((res)=>{
          if(res){
            // if(!res.data){
            //   return false;
            // }
            if(res.data.code===200){
              this.warehouseObj = {};
              this.warehouseName = '';//仓库
              this.shopNumber = null;//申领数量
              this.deliveryFlag = null;//配送方式
              this.$toast.success('订单提交成功！');
              this.getSearchSiteIdHave(this.siteId);
              this.getDataForm();
            }else if(res.data.code===999){
              this.$toast.fail(res.data.msg);
              return false;
            }else{
              this.$toast.fail('订单提交失败！');
              return false;
            }
          }
        });
      }else{
        this.$toast.fail('库存不足！');
        return false;
      }
    },
    // // 筛选自提或邮寄
    // getFilter(type){
    //   this.deliveryType = type;
    // },
    getTabVan(value){
      if(value==='2'){
        // 申领记录列表
        // 默认自取参数
        this.deliveryType = 1;
        this.getList();
      }
    },
    getConfig(item) {
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'getLocation',
                  'scanQRCode',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                console.log('wx.ready----')
                this.getScanModal(item)
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },
    getLastModal(item,type){
      consumablesOrderSortRelationList({
        orderId:item.orderId
      }).then((res)=>{
        if(res){
          if(res.data){
            this.lastFlag = true;
            this.lastObj = item;
            this.lastType = type;
            if(res.data.rows.length>0){
              this.lastList = res.data.rows;
            }else{
              this.lastList = [];
            }
          }
        }
      });
    },
    // 出库
    getScanModal(item){
      let that = this;
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
        isHighAccuracy: true,
        success: data=> {
          console.log(data,'getLocation');
          that.latitude = data.latitude;
          that.longitude = data.longitude;
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            zoom: 3,                      // 放大倍数(1-10)
            focus: true,                  // 启用自动对焦
            autoZoom: true,               // 启用自动缩放(微信7.0.12+)
            inverse: true,                // 尝试识别反色条码
            success: res => {
              console.log(res,'scanQRCode');
              if (res && res.resultStr) {
                let codeStr = res.resultStr.split(',');
                if(codeStr[1]&&(codeStr[1].length>10&&codeStr[1].length<13)){
                  if(codeStr[1].substring(0,1)!=='F'){
                    this.$toast('请选择正确的箱号对应的条形码！')
                    return false;
                  }
                  // else if(codeStr[1].substring(0,2)!=='FI'){
                  //   this.$toast('请选择正确的箱号对应的条形码！')
                  //   return false;
                  // }
                  //11或12位
                  let params = {
                    "orderId": item.orderId,
                    "whId": item.whId,
                    "barcode":codeStr[1],
                    "longitude":that.longitude,
                    "latitude":that.latitude,
                  }
                  console.log(params)
                  consumablesOrderSortRelation(params).then((response) => {
                    if (response) {
                      let res = response.data;
                      if (res.code) {
                        if (res.code === 200) {
                          consumablesBranchOrderInfoId({
                            orderId:item.orderId
                          }).then((resp) => {
                            let res = resp.data;
                            if (res) {
                              if (res.code && res.code === 200) {
                                if(res.data.status===1){
                                  Dialog.alert({
                                    title: '提示',
                                    message: `预计还有1箱，继续扫描`,
                                    confirmButtonText: '出库',
                                    theme: 'round-button',
                                  }).then(() => {
                                    that.getScanModal(item);
                                  });
                                }else{
                                  that.$toast('提交成功！');
                                  that.getLastModal(item,'yes');
                                  that.page1 = 1;
                                  that.getList();
                                }
                              } else {
                                if (res.msg) {
                                  that.$toast(res.msg);
                                }
                              }
                            }
                          });
                        }else{
                          that.page1 = 1;
                          that.getList();
                          that.getLastModal(item,'no');
                        }
                      } else {
                        if (res.msg) {
                          that.$toast(res.msg);
                          return false;
                        }
                      }
                    }
                  });
                }else{
                  that.$toast('请选择正确的箱号对应的条形码！')
                  return false;
                }
              }
            },
            fail: err => {
              console.log('wx.scanQRCode方法 ，失败');
              console.error(err);
              console.error(err.errMsg);
              that.getConfig(item);
            }
          });
        },
        fail: err => {
          console.log('wx.getLocation方法 ，失败');
          console.error(err);
          console.log(err.errMsg);
          that.getConfig(item);
          if (err.errMsg.includes('user deny')) {
            that.$toast('您拒绝了位置授权，请前往设置开启');
          } else {
            that.$toast(`获取位置失败：${err.errMsg}`);
          }
        }
      });
    },
    getList(){
      this.loading1 = true;
      this.finished1 = false;
      if(this.listParams.pageNum===1){
        this.orderList = [];
      }
      consumablesBranchOrderList(this.listParams).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(res.data){
            this.loading1 = false;
            if(res.data.code===200){
              this.totals1 = res.data.total;
              this.totalPages1 = Math.ceil(res.data.total / this.size2);
              if (res.data.rows == null || res.data.rows.length === 0) {
                this.finished1 = true;
                this.orderList = [];
                return false;
              } else {
                if (this.page2 > 1) {
                  this.orderList = this.orderList.concat(res.data.rows);
                } else {
                  this.orderList = res.data.rows;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size2) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page2 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    getListForm(){
      console.log(this.lastType)
      if(this.lastType==='yes'){
        this.getDataForm();
      }
    },
    getDataForm(){
      let params = {
        pageSize:this.size2,
        pageNum:this.page2,
        branchId:this.siteId,
        status:0,
        type:0,//订单类型，0:热敏纸、1:其他
        orderByColumn:'createTime',
        isAsc:'desc',//desc:降序，asc:升序
      }
      consumablesBranchOrderList(params).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(res.data){
            if(res.data.code===200){
              if(res.data.rows.length>0){
                this.formList = res.data.rows;
              }else{
                this.formList = []
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      })
    }
  },
  created() {
    // 网点编号
    if(this.$route.query.sid){
      this.siteId = this.$route.query.sid;
      this.regionCode = this.$route.query.sid.substring(0,4);
      this.getSearchSiteIdHave(this.siteId);
    }
    // 查询网点信息列表
    this.getUserSiteIdInfo();
    this.getDataForm();
  }
}
</script>

<template>
  <div class="content-inn">
    <van-popup
        v-model="lastFlag"
        round
        closeable
        :close-on-click-overlay="false"
        close-icon-position="top-right"
        position="center"
        :style="{ width:'90%' }"
        @close="getListForm"
    >
      <div class="logs-inner">
        <div class="logs-inner-head">
          箱号信息
        </div>
        <div class="logs-inner-title">
          <div class="con-sum-list" v-for="(item,index) in lastList" :key="index">
            <div class="logistics-number">
              <div class="lg-label">箱号:</div>
              <div class="lg-content">{{item.barcode}}</div>
            </div>
            <div class="logistics-number">
              <div class="lg-label">网点编号:</div>
              <div class="lg-content">{{item.branchId}}</div>
            </div>
            <div class="logistics-number">
              <div class="lg-label">操作员:</div>
              <div class="lg-content">{{item.orderNickName}}</div>
            </div>
            <div class="logistics-number" v-if="item.outboundTime&&item.status>0">
              <div class="lg-label">出库时间:</div>
              <div class="lg-content">{{item.outboundTime}}</div>
            </div>

          </div>
        </div>
      </div>
    </van-popup>
    <div class="prediction-notice" v-if="haveObj.orderStatus===1||haveObj.remainingVolumes<=1">
      预测当前还有 <span class="remainingRolls">{{ haveObj.remainingVolumes }}</span> 卷热敏纸
    </div>
    <div class="tabs">
      <van-tabs v-model="activeTab" animated swipeable sticky @click="getTabVan">
        <van-tab title="申领热敏纸" name="1"></van-tab>
        <van-tab title="申领记录" name="2"></van-tab>
      </van-tabs>
    </div>
    <div v-if="activeTab==='1'" class="tab-content">
      <div class="form-section">
        <div class="supply-item">
          <div class="quantity-section">
            <div class="warehouse-section" v-if="listSite.length>1">
              <div class="warehouse-label">
                <span class="v-bog">选择网点:</span>
              </div>
              <div class="form-items">
                <van-field
                    v-model="siteId"
                    name="branchId"
                    label=""
                    placeholder="请选择网点"
                    :rules="[{ required: true, message: '请选择网点' }]"
                    readonly
                    @click="showSiteIdPicker = true"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down" />
                  </template>
                </van-field>
                <van-popup
                    v-model="showSiteIdPicker"
                    round
                    position="bottom"
                >
                  <van-picker
                      show-toolbar
                      title="选择网点"
                      :columns="listSite"
                      value-key="branchId"
                      @confirm="onSiteIdConfirm"
                      @cancel="showSiteIdPicker = false"
                  />
                </van-popup>
              </div>
            </div>
            <div class="warehouse-section">
              <div class="warehouse-label">
                <span class="v-bog">选择仓库:</span>
                <span class="v-bogs" v-show="warehouseName">库存: {{ warehouseObj.boxNumber }}箱</span>
              </div>
              <div class="form-items">
                <van-field
                    v-model="warehouseName"
                    name="warehouseName"
                    label=""
                    placeholder="请选择仓库"
                    :rules="[{ required: true, message: '请选择仓库' }]"
                    readonly
                    @click="showWarehousePicker = true"
                >
                  <template #right-icon>
                    <van-icon name="arrow-down" />
                  </template>
                </van-field>
                <van-popup
                    v-model="showWarehousePicker"
                    round
                    position="bottom"
                >
                  <van-picker
                      show-toolbar
                      title="仓库选择"
                      :columns="warehouseList"
                      value-key="warehouseName"
                      @confirm="onWarehouseConfirm"
                      @cancel="showWarehousePicker = false"
                  />
                </van-popup>
              </div>
              <div class="warehouse-address" v-show="warehouseName">
                地址: {{ warehouseObj.warehouseAddress }}<br />
              </div>
            </div>
            <div class="quantity-input">
              <span class="quantity-label">可申领数量:</span>
              <div class="quantity-controls">{{shopNumber}}
                <!--                <van-field type="digit" min="1" readonly="readonly" @keyup="getOnInput()" v-model.trim="shopNumber" />-->
              </div>
              <span class="unit-label">箱</span>
              <span class="unit-text">(每箱包含20卷。)</span>
            </div>
            <div class="delivery-section" v-if="logsFlag">
              <div class="delivery-label">领取方式：</div>
              <div class="delivery-options">
                <van-radio-group v-model="deliveryFlag" direction="horizontal">
                  <!--                  <div  class="delivery-option">-->
                  <van-radio name="1">自取</van-radio>
                  <!--                  </div>-->
                  <!--                  <div  class="delivery-option">-->
                  <van-radio name="0" v-if="logsFlag">配送</van-radio>
                  <!--                  </div>-->
                </van-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-section">
        <button class="submit-btn" v-if="haveObj.orderStatus===1" @click="getSubmitData">
          提交
        </button>
        <button class="submit-btn gary" v-else @click="getReason">
          提交
        </button>
      </div>
      <div class="">
        <div class="form-box-list" v-for="(item,index) in formList" :key="index">
          <div class="record-item">
            <div class="item-box-s">
              <div class="record-header">
                <span class="record-id">网点编号: {{ item.branchId }}</span>
              </div>
              <div class="record-details">
                <!--                <div class="record-row">-->
                <!--                  <span>网点编号:</span>-->
                <!--                  <span class="record-quantity">{{item.branchId}}</span>-->
                <!--                </div>-->
                <div class="record-row">
                  <span>申领物品:</span>
                  <span class="record-quantity">热敏纸 × {{item.boxNumber}}箱</span>
                </div>
                <div class="record-row">
                  <span>仓库:</span>
                  <span>{{ item.warehouseName }}</span>
                </div>
                <div class="record-row">
                  <span>领取方式:</span>
                  <span>{{item.distributionType===1?'自取':'配送'}}</span>
                </div>
                <div class="record-row">
                  <span>申领时间:</span>
                  <span>{{item.createTime}}</span>
                </div>
              </div>
            </div>
            <div class="item-box">
              <!-- 状态，-1:处理中、0:待出库、 1:正在出库、 2:配送中、3:待提取、4:配送完成、5:已提取、6:取消、7:失败-->
              <div class="record-actions" v-if="item.status<4">
                <img src="@/assets/images/code.gif" alt="" />
                <button class="action-btn sorting-btn" @click="getScanModal(item)">
                  扫描条形码
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="activeTab==='2'" class="tab-content">
      <!--      <div class="modal-options">-->
      <!--        <div class="modal-option" :class="deliveryType===1?'active':''" @click="getFilter(1)">自取</div>-->
      <!--        <div class="modal-option" :class="deliveryType===0?'active':''" @click="getFilter(0)">配送</div>-->
      <!--      </div>-->
      <div class="record-content">
        <!-- 列表 -->
        <div class="record-list">
          <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false" @load="onLoad">
            <div class="record-item" v-for="(item,index) in orderList" :key="index">
              <!--              <div class="record-header">-->
              <!--                <span class="record-id">申请编号: {{ item.orderId }}</span>-->
              <!--              </div>-->
              <!--              <div class="record-details">-->
              <!--                <div class="record-row">-->
              <!--                  <span>申领物品:</span>-->
              <!--                  <span class="record-quantity">热敏纸 × {{item.boxNumber}}箱</span>-->
              <!--                </div>-->
              <!--                <div class="record-row">-->
              <!--                  <span>仓库:</span>-->
              <!--                  <span>{{ item.warehouseName }}</span>-->
              <!--                </div>-->
              <!--                <div class="record-row">-->
              <!--                  <span>领取方式:</span>-->
              <!--                  <span>{{item.distributionType===1?'自取':'配送'}}</span>-->
              <!--                </div>-->
              <!--                <div class="record-row">-->
              <!--                  <span>申领时间:</span>-->
              <!--                  <span>{{item.createTime}}</span>-->
              <!--                </div>-->
              <!--                <div class="record-actions" v-if="item.status<4">-->
              <!--                  <button class="action-btn sorting-btn" @click="getScanModal(item)">-->
              <!--                    出库-->
              <!--                  </button>-->
              <!--                </div>-->
              <!--                <div class="record-row" v-else>-->
              <!--                  <span>申领状态:</span>-->
              <!--                  <span>-->
              <!--                    {{item.status===-1?'处理中':''}}-->
              <!--                    {{item.status===0?'待出库':''}}-->
              <!--                    {{item.status===1?'正在出库':''}}-->
              <!--                    {{item.status===2?'配送中':''}}-->
              <!--                    {{item.status===3?'待提取':''}}-->
              <!--                    {{item.status===4?'配送完成':''}}-->
              <!--                    {{item.status===5?'已提取':''}}-->
              <!--                    {{item.status===6?'取消':''}}-->
              <!--                    {{item.status===7?'失败':''}}-->
              <!--                  </span>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="item-box-s">
                <div class="record-header">
                  <span class="record-id">网点编号: {{ item.branchId }}</span>
                </div>
                <div class="record-details">
                  <div class="record-row">
                    <span>申领物品:</span>
                    <span class="record-quantity">热敏纸 × {{item.boxNumber}}箱</span>
                  </div>
                  <div class="record-row">
                    <span>仓库:</span>
                    <span>{{ item.warehouseName }}</span>
                  </div>
                  <div class="record-row">
                    <span>领取方式:</span>
                    <span>{{item.distributionType===1?'自取':'配送'}}</span>
                  </div>
                  <div class="record-row">
                    <span>申领时间:</span>
                    <span>{{item.createTime}}</span>
                  </div>
                  <div class="record-row" v-if="item.outboundTime&&item.status>0">
                    <span>出库时间:</span>
                    <span>{{item.outboundTime}}</span>
                  </div>
                </div>
              </div>
              <div class="item-box">
                <!-- 状态，-1:处理中、0:待出库、 1:正在出库、 2:配送中、3:待提取、4:配送完成、5:已提取、6:取消、7:失败-->
                <div class="record-actions" v-if="item.status<4">
                  <img src="@/assets/images/code.gif" alt="" />
                  <button class="action-btn sorting-btn" @click="getScanModal(item)">
                    扫描条形码
                  </button>
                </div>
                <div class="record-actions" v-else-if="item.status===4||item.status===5">
                  <span class="sp-act" @click="getLastModal(item,'no')">
                    查看
                  </span>
                </div>
                <div class="record-actions" v-else-if="item.status===6">
                  <span style="color: red">已取消</span>
                </div>
                <div class="record-actions" v-else></div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.logs-inner{
  padding:0 20px 30px;
  .logs-inner-head{
    padding: 30px  ;
    font-weight: bold;
    font-size: 34px;
    text-align: center;
  }
  .con-sum-list{
    border-radius: 10px;
    box-shadow:2px 3px 20px 5px rgba(2, 2, 2, 0.2);
    margin-bottom: 30px;
  }
}
.hg{
  min-height: 60px;
  line-height: 60px;
}
.logistics-number{
  padding:10px 20px;
  box-sizing: border-box;
  .lg-label{
    display: inline-block;
    vertical-align: top;
  }
  .lg-content{
    display: inline-block;
    word-wrap:break-word;
    white-space: normal;
  }
  .num-order{
    color: #03A9F4;
    vertical-align: top;
  }
  .copy-button{
    display: inline-block;
    background-color: #E1F5FE;
    color: #03A9F4;
    height: 40px;
    line-height: 40px;
    padding:0 10px;
    box-sizing: border-box;
    border: none;
    outline: none;
    border-radius:8px;
    margin-left: 6px;
  }
}
.form-box-list{
  padding: 0 20px;
}
.prediction-notice{
  background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%);
  color: white;
  padding: 20px 20px;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  border-bottom: 1px solid #e9ecef;
}
.van-cell{
  border: 2px solid #e9ecef;
  border-radius: 10px;
}
.form-section {
  padding: 20px 20px 0;
}
.modal-options{
  padding: 0 30px;
  display: flex;
  flex-wrap: wrap;
}
.modal-option{
  background-color: #f5f5f5;
  border-radius: 35px;
  padding: 5px 35px;
  margin-right: 25px;
  margin-bottom: 20px;
  color: #666;
  border: 2px solid #8f8f8f;
}
.active{
  background-color: #e62d2d;
  border: 2px solid #e62d2d;
  color: white;
}


.supply-item {
  background: white;
  border: 2px solid #e17055;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  //transition: all 0.3s ease;
}

.supply-item:hover {
  border-color: #e17055;
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.1);
}

.supply-header {
  padding:30px 20px;
  background: linear-gradient(135deg, #fff5f3 0%, #fef5f3 100%);
}

.supply-name {
  font-size: 28px;
  font-weight: 600;
  color: #2d3436;
  margin-bottom: 10px;
}

.supply-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.quantity-section {
  background: white;
  padding: 20px;
  border-top: 1px solid #f1f3f4;
}

.warehouse-section {
  margin-bottom: 20px;
}

.warehouse-label {
  font-size: 28px;
  color: #495057;
  margin-bottom: 8px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  .v-bogs{
    color: #222;
  }
}

.unit-text{
  font-size: 24px;
  color: #6c757d;
  margin-top: 5px;
  margin-left: 5px;
}
.warehouse-select {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 28px;
  background: white;
  color: #495057;
  transition: border-color 0.3s ease;
}

.warehouse-select:focus {
  outline: none;
  border-color: #e17055;
  box-shadow: 0 0 0 3px rgba(225, 112, 85, 0.1);
}

.warehouse-address {
  font-size: 24px;
  color: #6c757d;
  padding-top: 10px;
  padding-left: 5px;
}

.quantity-input {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.quantity-label {
  font-size: 28px;
  color: #495057;
  margin-right: 15px;
  min-width: 80px;
  font-weight: 500;
}

.quantity-controls {
  display: flex;
}

.quantity-btn {
  background: #f8f9fa;
  border: none;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  font-size: 20px;
  color: #6c757d;
  font-weight: 600;
}

.quantity-input input {
  border: none;
  width: 70px;
  height: 45px;
  text-align: center;
  font-size: 18px;
  background: #f8f9fa;
  font-weight: 600;
  color: #6c757d;
  cursor: not-allowed;
}

.unit-label {
  margin-left: 15px;
  font-size: 28px;
  color: #6c757d;
  font-weight: 500;
}

.delivery-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #f1f3f4;
  display: flex;
  flex-direction: row;
}

.delivery-label {
  font-size: 28px;
  color: #495057;
  margin-bottom: 12px;
  font-weight: 500;
}

.delivery-options {
  display: flex;
  gap: 20px;
}
.van-radio-group{
  display: flex;
  gap: 20px;
  width: 100%;
}

.delivery-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1;
  padding: 20px 50px 6px 20px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.3s ease;
  //margin-right: 30px;
}

.radio-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
  transition: all 0.3s ease;
}


.option-text {
  font-size: 28px;
  color: #495057;
  font-weight: 500;
}

.submit-section {
  padding:10px 20px 20px;
  //background: #f8f9fa;
}
.submit-btn {
  width: 100%;
  //background: #6c757d;
  background:#e62d2d;
  color: white;
  border: none;
  padding: 25px;
  font-size:28px;
  font-weight: 600;
  border-radius: 12px;
  cursor: not-allowed;
  position: relative;
  overflow: hidden;
}

.submit-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.gary{
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.record-content {
  padding: 20px;
}

.record-list {
  background: transparent;
}

.record-item {
  display: flex;
  flex-direction: row;
  background: white;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 15px;
  //border-left: 4px solid #ddd;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  .item-box-s{
    width: 65%;
  }
  .item-box{
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    width: 35%;
  }
}

.record-item.pending {
  border-left-color: #fdcb6e;
}

.record-item.approved {
  border-left-color: #00b894;
}

.record-item.rejected {
  border-left-color: #e17055;
}

.record-item.completed {
  border-left-color: #74b9ff;
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.record-id {
  font-size: 28px;
  color: #495057;
  font-weight: 600;
}

.record-status {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  color: white;
  font-weight: 500;
}

.record-actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  img{
    display: flex;
    justify-content: center;
    flex: 1;
    width: 100%;
    margin: 0 auto 10px;
  }
  .sp-act{
    display: inline-block;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 20px 0;
    width: 120px;
    text-align: center;
  }
}

.action-btn {
  display: flex;
  background: linear-gradient(135deg, #00cec9, #00b894);
  color: white;
  border: none;
  padding: 14px 26px;
  border-radius: 6px;
  font-size: 28px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.sorting-btn {
  background: linear-gradient(135deg, #fdcb6e, #f39c12);
}
.record-row {
  display: flex;
  //justify-content: space-between;
  margin-bottom: 3px;
  color: #6c757d;
  .record-quantity{
    color: #222;
  }
}
</style>